import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppInitializerService } from '@app/app-initializer.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { BaseService } from '@app/system/services/base.service';
import { HandleBarPipe } from '@app/system/pipes/handle-bar/handle-bar.pipe';
import { LocaleService } from '@app/system/services/locale.service';

@Injectable({
	providedIn: 'root'
})
export class ApiService {

	headers: any = {
		'Content-Type': 'application/json'
	};

	constructor(
		private http: HttpClient,
		private gfService: GlobalFunctionService,
		private appInit: AppInitializerService,
		private baseService: BaseService,
		private locale: LocaleService
	) { }

	getEventBasedText(userDetail: any, eventName: string, resourceTypeID: number, resourceFormat: number = null) {
		let userName = '';
		if (typeof userDetail === 'string') {
			userName = userDetail;
		} else if (userDetail && Object.keys(userDetail).length) {
			userName = `${userDetail.firstName}${userDetail.lastName
				? ' ' + userDetail.lastName
				: ''}`;
		}
		let resourceType = '';
		let resourceName = '';
		if (resourceTypeID) {
			const resource = this.baseService.referenceType('resourceType', resourceTypeID);
			if (resource) {
				resourceType = resource.caption.toLowerCase();
				resourceName = resource.key;
			}
		}
		let format = '';
		let formatType = '';
		if (resourceFormat) {
			const resource = this.baseService.referenceType('resourceFormat', resourceFormat);
			if (resource) {
				format = resource.caption.toLowerCase();
				formatType = resource.key;
			}
		}
		let returnString = '';
		if (eventName === 'READ'.toLowerCase()) {
			if (resourceName === 'course') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_completed_a_course'), { userName });
			} else if (resourceName === 'playlist') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_completed_a_playlist'), { userName });
			} else if (resourceName === 'answer') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_read_a_resource'), { userName });
			} else {
				if (formatType === 'video') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_watched_a_format'), { userName, format });
				} else if (formatType === 'audio') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_listened_a_format'), { userName, format });
				} else if (formatType === 'link') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_viewed_a_format'), { userName, format });
				} else if (formatType === 'page') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_read_a_format'), { userName, format });
				} else if (formatType === 'image') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_viewed_a_format'), { userName, format });
				} else if (formatType === 'document') {
					returnString = new HandleBarPipe().transform(this.locale.translate('user_read_a_format'), { userName, format });
				}
			}
		} else if (eventName === 'PostConversation'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_commented_on_resource'), { userName, resourceType });
		} else if (eventName === 'Forward'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_forwarded_a_resource'), { userName });
		} else if (eventName === 'Assign'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_assigned_a_resource'), { userName });
		} else if (eventName === 'CreatePlaylist'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_created_a_playlist'), { userName });
		} else if (eventName === 'Bookmark'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_bookmarked_a_resource'), { userName, resourceType });
		} else if (eventName === 'Rating'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_rated_a_format'), { userName, format });
		} else if (eventName === 'GenerateCertificate'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_generated_certificate_for_resource'), { userName, resourceType });
		} else if (eventName === 'RequestEnrollment'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_requested_enrollment_for_resource'), { userName, resourceType });
		} else if (eventName === 'NominationUser'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_nominated_user_for_resource'), { userName, resourceType });
		} else if (eventName === 'CreateKnowledgeBead'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_shared_format'), { userName, format });
		} else if (eventName === 'PostQuestion'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_asked_a_question'), { userName });
		} else if (eventName === 'PostAnswer'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_answered_a_question'), { userName });
		} else if (eventName === 'RegisterLearning'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_registered_learning'), { userName });
		} else if (eventName === 'EndorseUser'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_endorsed_the_user'), { userName });
		} else if (eventName === 'AssignKnowledgeCard'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_assigned_a_knowledge_card'), { userName });
		} else if (eventName === 'WGRequests'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_requested_the_workgroup'), { userName });
		} else if (eventName === 'WGJoins'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_joined_workgroup'), { userName });
		} else if (eventName === 'WGRejects'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_rejected_the_workgroup'), { userName });
		} else if (eventName === 'WGNew'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_created_the_workgroup'), { userName });
		} else if (eventName === 'WGDelete'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_deleted_the_workgroup'), { userName });
		} else if (eventName === 'Reassign'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_re_assigned_the_assignment'), { userName });
		} else if (eventName === 'Follow'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_follow'), { userName });
		} else if (eventName === 'Like'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_liked_a_conversation'), { userName });
		} else if (eventName === 'Feedback'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_posted_a_feedback'), { userName });
		} else if (eventName === 'AssignmentSubmission'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_submitted_the_assignment'), { userName });
		} else if (eventName === 'UnLike'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_disliked_a_conversation'), { userName, resourceType });
		} else if (eventName === 'register'.toLowerCase()) {
			if (['internalEvent', 'externalEvent'].includes(resourceName)) {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_attending_an_event'), { userName });
			} else if (resourceName === 'mooc') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_attending_a_course'), { userName });
			} else if (resourceName === 'course') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_enrolled_into_a_course'), { userName });
			}
		} else if (eventName === 'requestregistration'.toLowerCase()) {
			if (['internalEvent', 'externalEvent'].includes(resourceName)) {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_requesting_to_attend_an_event'), { userName });
			} else if (resourceName === 'mooc') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_requesting_to_attend_a_course'), { userName });
			} else if (resourceName === 'course') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_requesting_to_enroll_into_a_course'), { userName });
			}
		} else if (eventName === 'didnotattend'.toLowerCase()) {
			if (['internalEvent', 'externalEvent'].includes(resourceName)) {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_did_not_attend_an_event'), { userName });
			} else if (resourceName === 'mooc') {
				returnString = new HandleBarPipe().transform(this.locale.translate('user_is_did_not_attend_a_course'), { userName });
			}
		} else if (eventName === 'joininasking'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('user_joined_in_asking_a_question'), { userName });
		} else if (eventName === 'registerlearning'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('registered_learning'), { userName });
		} else if (eventName === 'nominateuser'.toLowerCase()) {
			returnString = new HandleBarPipe().transform(this.locale.translate('nominated_a_user'), { userName });
		}
		return returnString;
	}

	add(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		
		return this.http.post(api, params, options);
		
	}

	userBasicProfile(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/basicprofile/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	userCompetency(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/competencies/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	userSkillCompetency(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/internal/assessment/all?userID=${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	updateIntAssSkill(params: any = {}, id: number, headers: any = {}) : Observable<any>{
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers); 
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/internal/assessment`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}
	
	addSkill(params: any = {}, id: number, headers: any = {}) : Observable<any>{
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers); 
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/internal/assessment`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	userSearch(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/search`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	userAnalytics(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/profileanalytics/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	updateThumbnail(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		delete headers['Content-Type'];
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/profile/picture`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateSkill(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/updateskill`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	moderateCertificate(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learning/${id}/moderation`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	list(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/getuserslist`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getForms(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/form`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	addCertification(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		delete headers['Content-Type'];
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learning`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	addInterests(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/interest`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	addInternalAssessment(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/internal/assessment
		`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	getInterests(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/interest/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.get(api, options);
	}

	deleteInterest(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/interest/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	updateUserStatus(id: number, status: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/profile/${id}/${status}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, {}, options);
	}

	deleteUser(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/profile/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	getCertification(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learnings/${id}`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getEndorsement(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/endorsementcount`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getEndorsementDetail(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `endorsement/userlist`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getFeedback(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `feedback`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getCertificationDetail(params: any = {}, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learning${(id) ? '/' + id : ''}`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	updateCertification(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		delete headers['Content-Type'];
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learning`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	updateUser(params: any, id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/${id}`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	deleteCertification(id: number, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/learning/${id}`;
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.delete(api, options);
	}

	getEndorsementCertifyCount(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/endorsementandcertifications`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getInternalAssessment(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/internal/assessment`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getSharingForCompetency(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `resource/sharing`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getUserPost(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `search`;
		return this.http.get(api, options);
	}

	inviteUsers(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/invite`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.post(api, params, options);
	}

	getInvitedUsers(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/invite`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	revokeInvite(params: any, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `user/invite`;
		const options = {
			headers: new HttpHeaders(headers)
		};
		return this.http.put(api, params, options);
	}

	getUserActivity(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `analytics/useractivity`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}

	getLocation(params: any = {}, headers: any = {}): Observable<any> {
		const token = this.gfService.getCookie('token');
		if (token) {
			headers.token = token;
		}
		headers = this.gfService.JSONMerge(headers, this.headers);
		const api =
			this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `terms/search/location`;
		const options = {
			headers: new HttpHeaders(headers),
			params
		};
		return this.http.get(api, options);
	}
}
